<template>
    <ion-row>
        <ion-col class="my-1">
            <div class="line octo-gradient-light-background" style="height: 1px;"/>
        </ion-col>
    </ion-row>
    
    <ion-accordion class="bg-transparent" style="overflow: visible;">
        <ion-grid slot="header" class="ion-no-padding card-border light-medium-shadow" :class="gridColor">
            <ion-row
                class="pl-4 purple-purple-color d-flex"
                :class="(!$route.params.listId) ? 'timer-entry' : 'timer-entry-small'"
            >
                <ion-col class="center-y py-1" style="max-width: calc(100% - 56px)">
                    <div class="overflow-ellipsis">
                        <div
                            v-if="timer.type === REPEAT_CYCLE.ONCE"
                            class="coral-coral-color fs-larger"
                            style="padding-bottom: 3px;"
                        >
                            {{ convertFormat(timer.date, 'iso', TIME_FORMAT.DE) }}
                        </div>

                        <div
                            v-else
                            class="coral-coral-color fs-larger"
                            style="padding-bottom: 3px;"
                        >
                            {{ timer.interval.time }}
                        </div>

                        <skeleton-base
                            :show="!timer && !timerName"
                            :variants="{ dark: ION_VARIANT.PURPLE }"
                        >
                            <div
                                class="overflow-ellipsis fw-bolder"
                                style="padding-bottom: 3px;"
                            >
                                {{ timerName }}
                            </div>
                        </skeleton-base>

                        <div v-if="timer.type === REPEAT_CYCLE.ONCE">
                            {{ $t(`enumT.repeatCycle.${REPEAT_CYCLE.ONCE}`) }} {{ $t('label.at') }}
                            <span class="coral-coral-color">
                                {{ convertFormat(timer.date, 'iso', DATE_FORMAT.DE) }}
                            </span>
                        </div>

                        <div v-else-if="timer.interval.days" class="overflow-ellipsis-row-2">
                            {{ $t('messages.list.repeatEach2') }}
                            <span class="coral-coral-color">{{ timer.interval?.every ?? '' }}</span>
                            {{ $t(`enumT.repeatCycle.appendix.${timer.type}`) }} {{ $t('label.at') }}
                            <span class="coral-coral-color">
                                {{ translateJoin(sortedTimer, 'enumT.weekday.', ', ') }}
                            </span>
                        </div>
                    </div>
                </ion-col>

                <ion-col
                    v-if="requiresPermission(PERMISSION_KEY.LIST_REMINDER_DELETE)"
                    size="auto"
                    class="center-y"
                    style="justify-self: end;"
                >
                    <button-delete @click="$emit('deleteTimer', { id: timer.id, listId: timer.listId })"/>
                </ion-col>
            </ion-row>
        </ion-grid>

        <ion-grid
            slot="content" class="light-coral-color p-2"
            v-if="userStore.permission[PERMISSION_KEY.LIST_REMINDER_UPDATE]"
        >
            <timer-settings
                :css-class="cssClass"
                :timer="timer"
                :settings="settings"
                @edit="$emit('editTimer', $event)"
            />
        </ion-grid>
    </ion-accordion>
</template>

<script setup lang="ts">
import { IonAccordion, IonCol, IonGrid, IonRow } from "@ionic/vue";
import { computed, ref } from "vue";

import ButtonDelete from "@/components/button/ButtonDelete.vue";
import TimerSettings from "@/components/TimerSettings.vue";
import SkeletonBase from "@/components/various/SkeletonBase.vue";

import { useUserStore } from "@/stores/user";

import { translateJoin } from "@/functions/converter";
import { weekdaySort } from "@/functions/sort";
import convertFormat from "@/functions/luxon";

import { REPEAT_CYCLE, WEEKDAY } from "@/types/enum/general";
import { DATE_FORMAT, TIME_FORMAT } from "@/types/enum/luxonEnum";
import { PERMISSION_KEY } from "@/types/user";
import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { OrderTimerProps } from "@/types/props";
import { OrderTimerEmits } from "@/types/emits";
import { requiresPermission } from "@/functions/check";

const userStore = useUserStore()

const props = withDefaults(defineProps<OrderTimerProps>(), {
    gridColor: 'grey4-grey4-background'
})
defineEmits<OrderTimerEmits>()

const timerName = ref(String(props.timer.name))

const sortedTimer = computed<Array<WEEKDAY>>(() => {
    const sorted = props.timer
    return sorted.interval.days.sort(weekdaySort)
})
</script>

<style scoped>
.timer-entry {
    min-height: 97px;
}

.timer-entry-small {
    min-height: 77px;
}
</style>
